import { createAction } from '@reduxjs/toolkit';

const fetchClientsListRequest = createAction('appointment/fetchClientsRequest');
const fetchClientsListSuccess = createAction('appointment/fetchClientsSuccess');

const fetchServicesListRequest = createAction('appointment/fetchServicesRequest');
const fetchServicesListSuccess = createAction('appointment/fetchServicesSuccess');
const servicesStopLoader = createAction('appointment/servicesStopLoader');

const fetchSlotsRequest = createAction('appointment/fetchSlotsRequest');
const fetchSlotsSuccess = createAction('appointment/fetchSlotsSuccess');
const clearSlots = createAction('appointment/clearSlots');

const createOffTimeRequest = createAction('appointment/createOffTimeRequest');
const createOffTimeSuccess = createAction('appointment/createOffTimeSuccess');
const updateOffTimeRequest = createAction('appointment/updateOffTimeRequest');
const updateOffTimeSuccess = createAction('appointment/updateOffTimeSuccess');
const updatedOffTime = createAction('appointment/updatedOffTime');
const clearOffTimeData = createAction('appointment/clearOffTimeData');

const createAppointmentRequest = createAction('appointment/createAppointmentRequest');
const createAppointmentSuccess = createAction('appointment/createAppointmentSuccess');
const bookingAppointmentRequest = createAction('appointment/bookingAppointmentRequest');
const bookingAppointmentSuccess = createAction('appointment/bookingAppointmentSuccess');
const editBookedAppointmentRequest = createAction('appointment/editBookedAppointmentRequest');
const editBookedAppointmentSuccess = createAction('appointment/editBookedAppointmentSuccess');
const updateAppointmentRequest = createAction('appointment/updateAppointmentRequest');
const updateAppointmentSuccess = createAction('appointment/updateAppointmentSuccess');
const updatedAppointment = createAction('appointment/updatedAppointment');
const clearAppointmentData = createAction('appointment/clearAppointmentData');
const setPaymentRequiredData = createAction('appointment/setPaymentRequiredData');
const clearPaymentRequiredData = createAction('appointment/clearPaymentRequiredData');

const showAddAppointmentToast = createAction('appointment/showAddAppointmentToast');
const hideAddAppointmentToast = createAction('appointment/hideAddAppointmentToast');

const showEditAppointmentToast = createAction('appointment/showEditAppointmentToast');
const hideEditAppointmentToast = createAction('appointment/hideEditAppointmentToast');

const scrollToAppointment = createAction('appointment/scrollToAppointment');
const clearScrollAppointment = createAction('appointment/clearScrollAppointment');

const addClientRequest = createAction('appointment/addClientRequest');
const addClientSuccess = createAction('appointment/addClientSuccess');

const selectClient = createAction('appointment/selectClient');
const setSelectedClients = createAction('appointment/setSelectedClients');
const unselectClient = createAction('appointment/unselectClient');

const selectService = createAction('appointment/selectService');
const setClientsLimit = createAction('appointment/setClientsLimit');

const showEarnRegularPopup = createAction('appointment/showEarnRegularPopup');
const setEarnRegularPopupData = createAction('appointment/setEarnRegularPopupData');
const hideEarnRegularPopup = createAction('appointment/hideEarnRegularPopup');

const showTrophyPopup = createAction('appointment/showTrophyPopup');
const setTrophyPopupData = createAction('appointment/setTrophyPopupData');
const hideTrophyPopup = createAction('appointment/hideTrophyPopup');

export default {
  hideTrophyPopup,
  setTrophyPopupData,
  showTrophyPopup,
  hideEarnRegularPopup,
  setEarnRegularPopupData,
  showEarnRegularPopup,
  scrollToAppointment,
  clearScrollAppointment,
  fetchSlotsRequest,
  fetchSlotsSuccess,
  setSelectedClients,
  createAppointmentRequest,
  createAppointmentSuccess,
  updateAppointmentRequest,
  updateAppointmentSuccess,
  updatedAppointment,
  clearAppointmentData,
  fetchServicesListRequest,
  fetchServicesListSuccess,
  selectService,
  showAddAppointmentToast,
  hideAddAppointmentToast,
  showEditAppointmentToast,
  hideEditAppointmentToast,
  updateOffTimeRequest,
  updateOffTimeSuccess,
  createOffTimeRequest,
  createOffTimeSuccess,
  updatedOffTime,
  clearOffTimeData,
  addClientRequest,
  addClientSuccess,
  fetchClientsListRequest,
  fetchClientsListSuccess,
  selectClient,
  unselectClient,
  servicesStopLoader,
  bookingAppointmentRequest,
  bookingAppointmentSuccess,
  editBookedAppointmentSuccess,
  editBookedAppointmentRequest,
  setPaymentRequiredData,
  clearPaymentRequiredData,
  setClientsLimit,
  clearSlots,
};
